import React, { Component } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import withFetchHook from "../withFetchHook";
import fetchResidentMedications from "./fetchResidentMedications";

class RefillFormModal extends Component {
  state = {
    quantity: null
  }

  handleClose() {
    this.props.closeModal();
  }

  handleSave() {
    const { organizationName, medication } = this.props;

    this.props.fetch(`/organizations/${organizationName}/medications/${medication.id}/refill.json`, {
      method: "POST",
      data: {
        refill: {
          quantity: this.state.quantity,
          medication_id: medication.id
        }
      }
    }).then((data) => {
      this.updateMedications();
    })
  }

  updateMedications() {
    const { organizationName, residentId } = this.props;

    fetchResidentMedications(this.props.fetch, organizationName, residentId).then((data) => {
      this.props.updateMedications(data);
      this.props.closeModal();
    });
  }

  render() {
    const {
      show,
      medication,
      refill
    } = this.props;

    return (
      <Modal show={show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Refill {medication.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.hasEdit ? (
            <Form.Group controlId="medicationRefillQuantity">
              <Form.Label>Refill Quantity</Form.Label>
              <Form.Control
                type="number"
                value={this.state.quantity}
                onChange={(e) => this.setState({ quantity: e.target.value })} />
            </Form.Group>
          ) : (
            <div className="form-control-plaintext">
              You do not have permission to refill medications.
            </div>
          )}
        </Modal.Body>
        {this.props.hasEdit && (
          <Modal.Footer>
            <Button
              onClick={() => this.handleSave()}>
              Refill
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.refillModal.show,
    medication: state.ui.refillModal.refill,
    organizationName: state.organization.name,
    residentId: state.resident.id,
    hasDelete: state.current_user.permissions.includes("Delete"),
    hasEdit: state.current_user.permissions.includes("Edit")
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "refill" }}),
    updateMedications: (medications) => {
      dispatch({
        type: "UPDATE_MEDICATIONS",
        payload: { medications }
      });
    },
  };
};

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(RefillFormModal));
